<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card :title="title">
          <v-form @submit.prevent="handleSubmit">
            <v-container class="py-0">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.name"
                    name="name"
                    label="Name"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.code"
                    name="code"
                    label="Code"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.rfid"
                    name="rfid"
                    label="RFID"
                  />
                </v-col>

                <v-col cols="6">
                  <v-select
                    :disabled="isReadOnly"
                    :items="levels"
                    v-model="resource.level"
                    name="level"
                    label="Level"
                  />
                </v-col>
              </v-row>
              <v-row>
                <FormActions
                  :cancel="handleCancel"
                  :submit="handleSubmit"
                  :destroy="handleDestroy"
                  :canDestroy="canDestroy"
                  :canEdit="canEdit"
                  :canCreate="canCreate"
                  :isValid="isValid"
                  :submitting="submitting"
                />
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Formable from '@/mixins/formable';

export default {
  mixins: [Formable],
  data() {
    return {
      resourceName: 'PlantUser',
      levels: [
        { text: 'Regular', value: 1 },
        { text: 'Administrator', value: 2 },
      ],
    };
  },
};
</script>
